<template>
    <div class="common-body-view">
        <div  class="common-title">
            <img @click="back" src='../../img/left.png' style="width: 20px; height: 20px;">
            <span class="common-title-text">白鲨100服开区活动</span>
        </div>

        <div class="main" style="padding: 10px 10px;">
            <div style="display: flex;flex-direction: column;align-items: flex-start;font-size: 13px;color: #666666;text-align: left;">
                <span style="font-size: 12px;margin-top: 4px;color: #666666;font-weight: bold">
                    充值送
                    <span style="font-weight: bold;color: #f35815">修罗</span>，
                    白鲨100服8月2号开服当天（24:00截止）该服玩家实充<span style="color: #f35815">20元</span>送1修罗，实充<span style="color: #f35815">100元</span>送5修罗，奖励不叠加。
                </span>
                <span v-if="leaveTime > 0" style="font-weight: normal;color: #666666;font-size: 12px;margin-top: 3px;">活动倒计时：
                    <van-count-down style="display: inline;color: #e33b08;font-size: 12px;font-weight: bold;"
                                    ref="countDown"
                                    :time="leaveTime"
                                    :auto-start="true"
                                    @finish="finish"/>
                </span>
                <span v-else-if="leaveTime === -1" style="font-weight: normal;color: #888888;font-size: 12px;margin-top: 3px;">
                    活动已结束
                </span>
                <span style="font-size: 12px;margin-top: 4px;color: #888888">
                     注：修罗活动预计九月底出，活动出来后才可发放，发放前7天均未登录视为放弃奖励。
                </span>

                <div style="text-align: center;margin-top: 5px;">
                    <span style="color: #ec5312;font-size: 15px;font-weight: bold;">奖品展示</span>
                    <img src="../../img/xiuluo-award.gif" style="width: 100%;margin-top: 10px;">
                </div>

                <div style="width: 100%;margin-top: 5px;background-color: #f6f2ee;padding: 12px 8px;border-radius: 4px;box-sizing: border-box;">
                    <span>我的充值金额</span>
                    <div style="font-size: 22px;font-weight: bold;color: #f35815;margin-top: 3px;">
                        <span style="font-size: 12px;">￥</span>
                        <span>{{myRechargeNum}}</span>
                    </div>

                    <div class="pro-recharge-box">
                        <div class="pro-recharge-data" :style="{'width': rechargeData + '%'}"></div>
                        <div :style="myRechargeNum >= 20 ? 'color: #f35815' : 'color: #888888'" style="width: 1px;height: 10px;background-color: #f58b21;position: absolute;left: 20%;top: 14px;">
                            <div style="margin-top: 13px;margin-left: -10px;width: 40px;text-align: left;">20元</div>
                            <div style="margin-top: 1px;margin-left: -10px;width: 100px;text-align: left;">修罗x1</div>
                        </div>

                        <div :style="myRechargeNum >= 100 ? 'color: #f35815' : 'color: #888888'" style="width: 1px;height: 10px;background-color: #f58b21;position: absolute;right: 0;top: 14px;">
                            <div style="margin-top: 13px;margin-left: -10px;width: 40px;text-align: left;">100元</div>
                            <div style="margin-top: 1px;margin-left: -10px;width: 50px;text-align: left;">修罗x5</div>
                        </div>
                    </div>

                    <div style="margin-top:60px;display: flex;justify-content: space-between;align-items: center;">
                        <img v-if="rechargeStatus === 1" src="../../img/get-btn-wdc.png" style="width: 110px;cursor: unset;">
                        <img v-if="rechargeStatus === 2" @click="getAward" src="../../img/get-btn.png" style="width: 110px;cursor: pointer;">
                        <img v-if="rechargeStatus === 3" src="../../img/get-btn-ydj.png" style="width: 110px;cursor: unset;">
                        <img v-if="rechargeStatus === 4" src="../../img/get-btn-yff.png" style="width: 110px;cursor: unset;">

                        <div v-if="rechargeStatus === 2 || rechargeStatus === 3 || rechargeStatus === 4" style="font-size: 12px;">
                            <div v-if="drawNum === 1">
                                已登记修罗x1
                            </div>
                            <div v-if="drawNum === 5">
                                <div>已登记修罗x5</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="showLoading" style="position: fixed; top:0;left: 0; width: 100%;height: 100%;border-radius: 5px; ;display: flex;align-items: center;justify-content: center">
            <div style="width: 100px;height: 100px;border-radius: 5px; background-color: #444444;display: flex;align-items: center;justify-content: center">
                <van-loading type="spinner" />
            </div>
        </div>

    </div>
</template>

<script>

    import {request} from '@/api/request'
    import myloading from '@/components/myloading'
    import Toast from "vant/lib/toast";
    import '../../css/commonpage.css'

    export default {
        name: 'NewServer100.vue',
        components: {
            myloading
        },
        data() {
            return {
                showLoading: false,
                from: '',
                rechargeStatus: 1,//1:未达标 2：可领取  3：已领取 4 已发货
                myRechargeNum: 0,
                rechargeData: 0,
                drawNum: 0,
                leaveTime: -2,
            };
        },
        mounted() {
            this.initData();
        },
        methods: {
            back() {
                this.$parent.$parent.showMainMenu();
            },
            finish() {

            },
            initData() {
                this.showLoading = true;

                let options = {
                    url:"/sdkH5/get100WelfareInfo",
                    data: {}
                };

                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        console.log(res.data.data)
                        let data = res.data.data;
                        this.myRechargeNum = data.myChargeMoney;
                        this.rechargeStatus = data.myXLFlag;
                        this.drawNum = data.drawNum;
                        this.leaveTime = data.countDown;
                        this.rechargeData = Math.min(this.myRechargeNum, 100);
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            getAward() {
                this.showLoading = true;
                let options = {
                    url:"/sdkH5/getXL",
                    data: {}
                };

                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        Toast('登记成功');
                        this.initData();
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .main {
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .pro-pool-box {
        height: 12px;
        line-height: 12px;
        margin-top: 10px;
        width: 80px;
        border: 1px solid #ee520f;
        position: relative;
        background-color: rgba(238, 82, 15, 0.29);
        border-radius: 2px;
        color: #ffffff;
        text-align: center;
    }
    .pro-pool-data {
        position: absolute;
        top: 0;
        left: 0;
        background-color: #ee520f;
        height: 12px;
        width: 0;
    }

    .pro-recharge-box {
        width: 85%;
        height: 12px;
        line-height: 12px;
        margin-top: 10px;
        border: 1px solid #ee520f;
        background-color: rgba(238, 82, 15, 0.29);
        position: relative;
        border-radius: 2px;
        color: #ffffff;
        text-align: center;
        font-size: 12px;
    }
    .pro-recharge-data {
        position: absolute;
        top: 0;
        left: 0;
        background-color: #ee520f;
        height: 12px;
        width: 0;
    }
</style>